module.exports = __webpack_public_path__ + "static/P+Q_dm-b8e848b464568407472866bcd5a6f6f0.png";